export default "__VITE_ASSET__CnEk947m__"